import {CLEAR_REGULATORY_INFO, FETCH_REGULATORY_INFO} from "../../actions/actionTypes"

const initialState = {  
    data: {},
    loading: false,
};

const reducer = (state = initialState, action) => {

    switch (action.type) {    
        case FETCH_REGULATORY_INFO.REQUEST:
            return {...state,loading: true}
        case FETCH_REGULATORY_INFO.FAILURE:
            return {...state, loading: false}
        case FETCH_REGULATORY_INFO.SUCCESS:             
            return {...state, data: action.obj, loading: false}  
        case CLEAR_REGULATORY_INFO:
            return initialState;   
        default:
            return state
    }
}

export default reducer;